/**
 * Atlas PM · 项目星图 · 底部工具栏（对齐原型 #startools）
 *
 * 原型：底部居中，5 个按钮，文案逐字一致：
 *   `← 返回地图` `自动旋转` `依赖连线` `星轨光晕` `重置视角`
 * 前两个开关默认开启（与原型 `.on` 初始态一致）。
 */

export interface StarToolbarProps {
  autoRotate: boolean;
  showEdges: boolean;
  showTrails: boolean;
  onToggleAutoRotate: (on: boolean) => void;
  onToggleEdges: (on: boolean) => void;
  onToggleTrails: (on: boolean) => void;
  onReset: () => void;
  onBack: () => void;
}

export default function StarToolbar({
  autoRotate,
  showEdges,
  showTrails,
  onToggleAutoRotate,
  onToggleEdges,
  onToggleTrails,
  onReset,
  onBack,
}: StarToolbarProps) {
  const toggle = (active: boolean, setter: (on: boolean) => void) => () => setter(!active);

  return (
    <div className="star-tools" role="toolbar" aria-label="星图工具栏">
      <button type="button" className="star-tool" onClick={onBack}>
        ← 返回地图
      </button>
      <span className="star-tool__div" />
      <button
        type="button"
        className={['star-tool', autoRotate ? 'on' : ''].join(' ')}
        aria-pressed={autoRotate}
        onClick={toggle(autoRotate, onToggleAutoRotate)}
      >
        自动旋转
      </button>
      <button
        type="button"
        className={['star-tool', showEdges ? 'on' : ''].join(' ')}
        aria-pressed={showEdges}
        onClick={toggle(showEdges, onToggleEdges)}
      >
        依赖连线
      </button>
      <button
        type="button"
        className={['star-tool', showTrails ? 'on' : ''].join(' ')}
        aria-pressed={showTrails}
        onClick={toggle(showTrails, onToggleTrails)}
      >
        星轨光晕
      </button>
      <button type="button" className="star-tool" onClick={onReset}>
        重置视角
      </button>
    </div>
  );
}
